export default ({
  extension = '',
  fileName = '',
  fileType = '',
  geometry = '',
  owner = '',
  parameters = '',
  taskName = ''
}) => ({
  _id: '',
  owner,
  createdAt: '',
  updatedA: '',
  label: 'Ogr2ogr',
  name: taskName,
  status: '',
  progress: '',
  group: 'Management',
  ready: true,
  links: [
    {
      source: 'originalVectorLayer',
      target: 'ogr2ogr'
    },
    {
      source: 'ogr2ogr',
      target: 'OutputVectorLayer'
    }
  ],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'originalVectorLayer',
      nodeLabel: 'original Vector Layer',
      argName: 'ogr2ogr:input_layer',
      nodeType: 'CONNECTION',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'GeoJSONVirtual',
          ip: '0.0.0.0',
          port: 30018,
          user: '',
          password: '',
          subtype: 'VECTOR',
          fileType: 'GeoJSONVirtual',
          filePath: geometry
        },
        source: {
          _id: 'temporal'
        },
        createMapServerElement: false,
        allowedFileTypes: ['KML', 'SHAPE', 'GeoJSON'],
        allowedMapServerElementTypes: [],
        allowedPGTypes: ['VECTOR']
      }
    },
    {
      x: 250,
      y: 50,
      id: 'ogr2ogr',
      argName: 'ogr2ogr',
      isNodeReady: true,
      methodUrl: '/GMS/vectorial/ogr2ogr',
      nodeLabel: 'ogr2ogr',
      nodeType: 'SUBTASK',
      paramList: [
        {
          multiValue: false,
          id: 'parameters',
          label: 'parameters',
          type: 'STRING',
          options: [],
          comments: 'Parámetros de ogr2ogr',
          required: false,
          value: `${parameters}`
        }
      ]
    },
    {
      x: 450,
      y: 50,
      id: 'OutputVectorLayer',
      nodeLabel: 'output Vector Layer',
      nodeType: 'CONNECTION',
      argName: 'ogr2ogr:output_vector_layer',
      connectionParams: {
        temporal: false,
        connector: {
          _id: 'temporal',
          type: 'FTP',
          ip: '192.168.1.43',
          port: 30018,
          user: 'demos_user',
          password: 'S9awVaLBVfEzt7NU',
          subtype: 'VECTOR',
          fileType,
          filePath: `/public/ogr2ogrAtlas/${fileName}.${extension}`
        },
        source: {
          _id: 'temporal'
        },
        allowedPGTypes: ['VECTOR'],
        allowedFileTypes: ['SHAPE', 'KML', 'GeoJSON'],
        allowedMapServerElementTypes: [],
        createMapServerElement: false
      }
    }
  ]
});
